import { render, staticRenderFns } from "./EditPass.vue?vue&type=template&id=ddb75044&scoped=true&"
import script from "./EditPass.vue?vue&type=script&lang=js&"
export * from "./EditPass.vue?vue&type=script&lang=js&"
import style0 from "./EditPass.vue?vue&type=style&index=0&lang=less&"
import style1 from "./EditPass.vue?vue&type=style&index=1&id=ddb75044&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb75044",
  null
  
)

export default component.exports